import { CardTraderConditionValueType } from "magic-shared-types";
import { StyledSelect } from "../common.style";
import { CARD_CONDITIONS_CARDTRADER } from "../../../constant";
import { Option } from "../../primitives";

interface ConditionDropdownProps {
  condition: CardTraderConditionValueType;
  setCondition: (arg1: CardTraderConditionValueType) => void;
}

export const ConditionDropdown = ({
  condition,
  setCondition,
}: ConditionDropdownProps) => {
  return (
    <StyledSelect
      value={condition}
      onChange={(e) =>
        setCondition(e.target.value as CardTraderConditionValueType)
      }
    >
      {CARD_CONDITIONS_CARDTRADER?.map((condition) => (
        <Option value={condition.value}>
          {condition.value} {`(${condition.code})`}
        </Option>
      ))}
    </StyledSelect>
  );
};
